import { render, staticRenderFns } from "./settingContentList.vue?vue&type=template&id=036a7a28"
import script from "./settingContentList.vue?vue&type=script&lang=js"
export * from "./settingContentList.vue?vue&type=script&lang=js"
import style0 from "./settingContentList.vue?vue&type=style&index=0&id=036a7a28&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports